<template>
  <div>
    <v-card-component :title="cardTitle" :icon="cardIcon">
      <v-row>
        <v-col cols="12" lg="4" sm="6" v-if="formType==='studEdit'">
          <span class="body-2 font-weight-medium">Student Full Name</span>
          <span class="error--text ml-1">*</span>
          <v-text-field type="text" placeholder="Student's Full Name"
            v-model="value.enquiry.studentName" class="my-0 py-1" :readonly="isReadonly"
            :disabled="isDisabled" single-line :required="isRequired">
          </v-text-field>
        </v-col>
        <v-col cols="12" v-else>
          <v-row>
            <v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Student First Name</span>
              <span class="error--text ml-1">*</span>
              <v-text-field type="text" placeholder="Student's First Name"
                v-model="value.studentFirstName" class="my-0 py-1"
                :required="(formType==='edit_registration' || formType==='registration')  ? true : isRequired"
                :readonly="(formType==='edit_registration' || formType==='registration') ? true : isReadonly"
                :disabled="(formType==='edit_registration' || formType==='registration' )  ? true : isDisabled"
                single-line>
              </v-text-field>
            </v-col>
            <v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Middle Name</span>
              <v-text-field type="text" placeholder="Student's Middle Name"
                v-model="value.studentMiddleName" class="my-0 py-1"
                :required="formType==='edit_registration' ? true : isRequired"
                :readonly="formType==='edit_registration' ? true : isReadonly"
                :disabled="formType==='edit_registration' ? true : isDisabled" single-line>
              </v-text-field>
            </v-col>
            <v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Last Name</span>
              <v-text-field type="text" placeholder="Student's Last Name"
                v-model="value.studentLastName" class="my-0 py-1"
                :readonly="((formType==='edit_registration')) ? true : isReadonly"
                :disabled="((formType==='edit_registration')) ? true : isDisabled" single-line>
              </v-text-field>
            </v-col>

          </v-row>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">Date of Birth </span>
          <span class="error--text">*</span>
          <custom-date-picker :maxToDate="maxToDate" :disabled="isApplication"
            v-model.trim="value.dateOfBirth" required/>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">Gender </span>
          <v-radio-group v-model="value.gender" row>
            <v-radio label="Boy" name="gender" value="Male" class="mr-7" required
              :readonly="isReadonly" :disabled="isDisabled">
            </v-radio>
            <v-radio label="Girl" name="gender" value="Female" required
              :readonly="isReadonly" :disabled="isDisabled">
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">Exposure to the English Language at present</span>
          <v-radio-group v-model="value.exposureToEnglishLanguage" row mandatory>
            <v-radio label="New to the Language" name="language" class="mb-4"
              value="New to the Language">
            </v-radio>
            <v-radio label="Familiar with the Language" name="language"
              value="Familiar with the Language">
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12">
          <v-row>
            <v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Mother Tounge </span>
              <v-text-field type="text" placeholder="First language of student" class="my-0 py-1"
                v-model="value.motherTongue">
              </v-text-field>
            </v-col>
            <v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Identification Marks </span>
              <v-text-field type="text" placeholder="Any Identification Mark" class="my-0 py-1"
                v-model="value.identificationMarks">
              </v-text-field>
            </v-col>
            <v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Place of birth </span>
              <v-text-field type="text" placeholder="Student's Place of Birth" class="my-0 py-1"
                v-model="value.placeOfBirth">
              </v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-component>
  </div>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import moment from 'moment'
export default {
  name: 'RegStudentElement',
  props: {
    formType: {
      default: '',
      type: String
    },
    value: {
      default: () => {},
      type: Object
    },
    isWritable: {
      default: 'false',
      type: String
    }
  },
  components: {
    VCardComponent,
    CustomDatePicker
  },
  data: function () {
    return {
      studType: 'NewAdmission',
      isApplication: false,
      isReadonly: false,
      isDisabled: false,
      cardTitle: '',
      isRequired: false,
      isRegistration: false,
      cardIcon: '',
      maxToDate: moment().format('YYYY-MM-DD')
    }
  },
  mounted: async function () {
    await this.writableData()
  },

  created: async function () {
    await this.writableData()
  },
  watch: {
    value (val) {
      console.log(val.dateOfBirth)
    }
  },
  methods: {
    writableData: async function () {
      if (this.isWritable === 'false') {
        this.isReadonly = true
        this.isDisabled = true
      }
      if (this.formType === 'application') {
        this.isApplication = true
      }

      this.cardTitle = 'Student Details'
      this.cardIcon = 'mdi-human-child'

      if (this.formType === 'edit_registration' || this.formType === 'admission') {
        this.isRegistration = true
        this.isReadonly = true
        this.isDisabled = true
      }
    }
  }
}
</script>
